import { createApp } from 'vue';

window.$ = window.jQuery = require('./vendor/jquery-3.1.1.min');
require('./vendor/bootstrap.min.js');
window.toastr = require('toastr');

import FloatingVue from 'floating-vue'

require('./vendor/jquery.pwstrength.min.js');


import './auth.js';

import { MaskInput } from 'vue-3-mask';


// Import all components you want to use
import Card from './components/Card.vue';

import CompanyCard from './components/client/CompanyCard.vue';
import TaskCompletionCard from './components/client/TaskCompletionCard.vue';
import CompanyPaymentCard from './components/client/CompanyPaymentCard.vue';
import ApplicationsCard from './components/client/ApplicationsCard.vue';
import CompanyOrdersCard from './components/client/CompanyOrdersCard.vue';
import ApplicationCard from './components/client/ApplicationCard.vue';
import ApplicationSubmission from './components/client/ApplicationSubmission.vue';
import EntryListing from './components/client/EntryListing.vue';
import EntrySingleListing from './components/client/EntrySingleListing.vue';
import EntrySingleAssociation from './components/client/EntrySingleAssociation.vue';
import CompanyHierarchyCard from './components/client/CompanyHierarchyCard.vue';
import SuperUserBrowser from './components/client/SuperUserBrowser.vue';
import CompanyUsers from './components/client/CompanyUsers.vue';
import EntityBrowser from './components/admin/EntityBrowser.vue';

import LogoLoader from './components/LogoLoader.vue';
import RegistrationForm from './components/RegistrationForm.vue';

import Accordions from './components/Accordions.vue';

// Create the Vue app
const app = createApp({});

// Register components globally
app.component('Card', Card);
app.component('logo-loader', LogoLoader);
app.component('registration-form', RegistrationForm);

app.component('company-card', CompanyCard);
app.component('task-completion-card', TaskCompletionCard);
app.component('company-payment-card', CompanyPaymentCard);
app.component('applications-card', ApplicationsCard);
app.component('company-orders-card', CompanyOrdersCard);
app.component('application-card', ApplicationCard);
app.component('application-submission', ApplicationSubmission);
app.component('entry-listing', EntryListing);
app.component('entry-single-listing', EntrySingleListing);
app.component('entry-single-association', EntrySingleAssociation);
app.component('company-hierarchy-card', CompanyHierarchyCard);
app.component('super-user-browser', SuperUserBrowser);
app.component('company-users', CompanyUsers);
app.component('entity-browser', EntityBrowser);

app.component('accordions', Accordions);

app.component('MaskInput', MaskInput);

app.use(FloatingVue);

// Mount the app to #app
app.mount('#app');

// jQuery Listeners
require('./client.js');
